exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Search_Search_2a-1u {\n    /*border: 1px solid black;*/\n}", ""]);

// Exports
exports.locals = {
	"Search": "Search_Search_2a-1u"
};